// extracted by mini-css-extract-plugin
export default {"dropzoneContainer":"pia2NtxZ5zhNG6JfaLOU","actionButtons":"ZwVOaONvx9Vwt5yUsPvI","body":"sbNYol3uItux3qRg8IHv","errorAlert":"rhsXDMKmHJhEFMYIf7_Q"};